var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_ClaimItemType_form_editTitle")
        : _vm.$t("label_essweb_ClaimItemType_form_viewTitle"),
      backgroundClass: "white",
      editBtn: !_vm.iSEdited,
      initData: _vm.claimItemType,
      checkData: [
        "claim_item_type_name",
        "sequence",
        "status",
        "claim_item_type_description",
        "max_value",
        "min_value",
        "remarks",
      ],
      delBtn: "",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_ClaimItemType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-switch", {
                          staticClass: "ml-4",
                          attrs: {
                            disabled: !_vm.iSEdited,
                            color: "primary",
                            label: _vm.claimItemType.status
                              ? _vm.$t(
                                  "label_essweb_ClaimItemType_form_activeLabel"
                                )
                              : "",
                          },
                          model: {
                            value: _vm.claimItemType.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.claimItemType, "status", $$v)
                            },
                            expression: "claimItemType.status",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.claimItemType.claim_item_type_name,
                            maxlength: "200",
                            label: _vm.$t(
                              "label_essweb_ClaimItemType_form_claimItemTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.claimItemType.claim_item_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { md: _vm.iSEdited ? 3 : 6 } },
                      [
                        _c("numberInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "11",
                            readonly: !_vm.iSEdited,
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 11]
                            ),
                            label: _vm.$t(
                              "label_essweb_ClaimItemType_form_sequenceLabel"
                            ),
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.claimItemType.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.claimItemType, "sequence", $$v)
                            },
                            expression: "claimItemType.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData:
                              _vm.claimItemType.claim_item_type_description,
                            maxlength: "500",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimItemType_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.claimItemType.claim_item_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            rules: _vm.$GetRules(["_Number_negative"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimItemType_form_minValueLabel"
                            ),
                            type: "number",
                            max: 5,
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.claimItemType.min_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.claimItemType, "min_value", $$v)
                            },
                            expression: "claimItemType.min_value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            min: _vm.claimItemType.min_value,
                            rules: _vm.$GetRules(["_Number_negative"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimItemType_form_maxValueLabel"
                            ),
                            type: "number",
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.claimItemType.max_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.claimItemType, "max_value", $$v)
                            },
                            expression: "claimItemType.max_value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_ClaimItemType_form_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            "no-resize": "",
                            maxlength: "500",
                            counter: "500",
                            dense: "",
                            "single-line": "",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.claimItemType.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.claimItemType, "remarks", $$v)
                            },
                            expression: "claimItemType.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }